<template>
  <v-container :key="this.$route.event_id">
    <v-layout text-xs-center wrap v-if="attendee && event">
      <v-flex mb-4>
        <v-img
          :src="event.banner"
          class="my-3"
          max-height="250"
          contain
        ></v-img>
        <div mb-4 xs-4 v-if="attendee.can_buy_activation">
          <h2 my-1 style="background: yellow" v-if="yell_buy_ticket">
            <v-icon>fas fa-exclamation-triangle</v-icon>&nbsp; 신청해주세요 /
            You need a ticket
          </h2>
          <v-btn
            v-if="this.has_products_in_category('team')"
            :to="`/events/${event.id}/product_category/team`"
            color="info"
            ><v-icon>fas fa-users</v-icon>&nbsp; 그룹 패스 Buy Team Pass</v-btn
          >
          <v-btn
            large
            v-if="this.has_products_in_category('parties')"
            :to="`/events/${event.id}/product_category/parties`"
            color="info"
            ><v-icon>fas fa-glass-cheers</v-icon>&nbsp; 파티 신청/ Parties
          </v-btn>
          <v-btn v-if="false" :to="`/events/${event.id}/join_team`"
            ><v-icon>fas fa-plus</v-icon>&nbsp; 그룹에 합류하기 Join Existing
            Team</v-btn
          >
          <v-btn
            large
            v-if="this.has_products_in_category('classes')"
            :to="`/events/${event.id}/product_category/classes`"
            color="info"
            ><v-icon>fas fa-university</v-icon>&nbsp; 강습 / Classes
          </v-btn>

          <v-btn
            large
            v-if="this.has_products_in_category('competitions')"
            :to="`/events/${event.id}/product_category/competitions`"
            color="info"
            ><v-icon>fas fa-trophy</v-icon>&nbsp; 대회 / Competitions
          </v-btn>

          <v-btn
            large
            v-if="this.has_products_in_category('merchandise')"
            :to="`/events/${event.id}/product_category/merchandise`"
            color="info"
            ><v-icon>fas fa-shopping-bag</v-icon>&nbsp; 추가 상품 / Products
          </v-btn>
        </div>

        <div mb-4 xs-4 v-if="!attendee.can_buy_activation && !attendee.active">
          <h2 my-1 style="background: yellow">
            <v-icon>fas fa-exclamation-triangle</v-icon>&nbsp; Ticketing In
            Progress
          </h2>
          Check orders for details
        </div>

        <div mb-8 xs-4 v-if="event_teams.length">
          <v-btn :to="`/events/${event.id}/my_team`" large
            ><v-icon>fas fa-users</v-icon>&nbsp; 팀/방 관리 My Team</v-btn
          >
        </div>

        <div mb-4 xs-4 v-if="event.lodge_id != 6 && attendee.can_buy_room">
          <v-btn
            :to="`/events/${event.id}/product_category/room`"
            large
            color="info"
            ><v-icon>fas fa-hotel</v-icon>&nbsp; 방구매 Reserve Room</v-btn
          >
        </div>
        <div mb-4 xs-4 v-if="attendee.can_buy_room && false">
          <v-btn :to="`/events/${event.id}/join_team`"
            ><v-icon>fas fa-plus</v-icon>&nbsp; 그룹에 합류하기 Join Existing
            Team</v-btn
          >
        </div>
        <div mb-4 xs-4 v-if="false &&
                             (
            (has_products_in_category('addons') &&
              (attendee.active && attendee.can_buy_addons)) ||
              event.mytaptags_preactive_options
              )
          "
        >
          <v-btn
            :to="`/events/${event.id}/product_category/addons`"
            large
            color="info"
            ><v-icon>fas fa-cart-plus</v-icon>&nbsp; Classes / Contests / Add-ons
            <!--추가상품 Add Ons-->
          </v-btn>
          <br/>
          <v-icon>fas fa-arrow-up</v-icon> 강습 / 대회 / 추가 상품  
          <!--추가상품 Add Ons-->
        </div>

        <div mb-4 xs-4 v-if="attendee.tickets.length > 0">
          <v-btn :to="`/events/${event.id}/my_ticket`" large
            ><v-icon>fas fa-ticket-alt</v-icon>&nbsp; 내 티켓 My Tickets</v-btn
          >
          <v-btn v-if="false" :to="`/events/${event.id}/wristband`" large
            ><v-icon>fas fa-ring</v-icon>&nbsp; Wristband Credits</v-btn
          >
        </div>
        <div mb-4 xs-4>
          <v-btn v-if="true" :to="`/events/${event.id}/get_transfer`"
            ><v-icon>fas fa-exchange-alt </v-icon>&nbsp; 양도 받기 Receive
            Transfer</v-btn
          >
        </div>

        <br />
        <v-btn :to="`/events/${event.id}/orders`"
          ><v-icon>fas fa-file-invoice-dollar</v-icon>&nbsp; 신청/구매내역
          Orders</v-btn
        >
        <br />
        <v-btn
          v-if="event.event_url.length > 5"
          :href="`${event.event_url}`"
          target="_blank"
          ><v-icon>fas fa-home</v-icon>&nbsp; {{ event.name }} 공식 홈페이지 /
          Event Home Page
        </v-btn>
        <br />
        <br />
        <br />
        <div v-if="attendee">
          <v-flex xs12>
            <v-btn :to="`/events/register/swing/${event.id}`"
              ><v-icon>person</v-icon>&nbsp; 이벤트 프로필 / Event Profile
            </v-btn>
            <br />
            <v-icon>fas fa-arrow-up</v-icon> 이벤트 프로필 & 파트너 정보
            <br />Event Profile and Competition Partner Information
          </v-flex>
          <v-flex style="margin-top: 16em">
            <img
              :src="
                `https://api.taptags.com/myprofile/event/${this.$route.params.event_id}/qrsvg.svg`
              "
              style="width: 300px"
            />
          </v-flex>
          <v-flex style="margin-top: 16em">
            <img
              :src="
                `https://api.taptags.com/myprofile/event/${this.$route.params.event_id}/qrsvg.svg?short=1`
              "
              style="width: 300px"
            />
          </v-flex>
            <!--
          <v-flex xs12>
            닉네임 Nickname: {{ attendee.nickname }} <br />소속 Affiliation:
            {{ attendee.affiliation }}
          </v-flex>
          <v-flex xs12>
            <br />
            <br />
            <br />
            <br />
            <small>Ref: #4L39q-XyFz4</small>
            <br />
            <small>XRel: #4724woifjw</small>
            <br />
            <small>{{event_options_pending}}</small>
            <br />
            <small>{{event_options_confirmed}}</small>
            <br />
            <small>XRel: #4724woifjw</small>
          </v-flex>
            -->
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';

export default {
  data: () => ({}),
  beforeMount: async function() {
    await this.$store.dispatch('loadEvents');
    await this.$store.dispatch('loadEventProducts', {
      event_id: this.$route.params.event_id,
    });
    await this.$store.dispatch('loadEventTeams', {
      event_id: this.$route.params.event_id,
    });
    await this.$store.dispatch('loadAttendees');

    await this.$store.dispatch('loadEventOrders', {
      event_id: this.$route.params.event_id,
    });
  },
  mounted() {
    // Check if we need a force reload
    axios.get('https://my.taptags.com/version.json').then(res => {
      let oldv = localStorage.getItem('last_version');
      // If we don't have any older version, stop now
      if (!oldv || oldv == 0) {
        localStorage.setItem('last_version', res.data.version);
        return;
      }

      // Check for version mismatch
      if (oldv != res.data.version) {
        // Remember new version
        localStorage.setItem('last_version', res.data.version);
        window.location.reload();
      }
    });
  },
  computed: {
    ...mapState(['events', 'attendees', 'event_teams', 'event_products', 'event_options_pending', 'event_options_confirmed']),
      
    yell_buy_ticket() {
        return (this.event_options_pending.length == 0 && this.event_options_confirmed.length == 0) 
    },

    attendee() {
      return this.attendees?.find(a => {
        return a.event_id == this.$route.params.event_id;
      });
    },
    event() {
      return this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
  },
  watch: {},
  methods: {
    has_products_in_category(category) {
      let p = this.products_in_category(category);
      if (!!!p || p.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    products_in_category(category) {
      return this.event_products?.filter(x => {
        return x.category == category;
      });
    },
    scroll_top() {
      var options = {
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: true,
        onStart: function(element) {
          // scrolling started
          console.log('scroll_top', 'start');
        },
        onDone: function(element) {
          // scrolling is done
          console.log('scroll_top', 'done');
        },
        onCancel: function() {
          // scrolling has been interrupted
          console.log('scroll_top', 'cancel');
        },
        x: false,
        y: true,
      };
      let cancelHandle = this.$scrollTo('#appbody', 10, options);
    },
  },
};
</script>

<style scoped>
.v-btn {
  min-width: 80%;
}
</style>
